export default {
  // ===========================================================================
  // Menu
  // ===========================================================================
  menu: {
    networkProfile: "Network profile",
    providerProfile: "Provider profile",
    customerProfile: "Customer profile",
    personProfile: "User profile",

    dashboard: "Dashboard",
    networks: "Networks",
    providers: "Providers",
    customers: "Customers",
    people: "People",
    tags: "Tags",

    requests: "Requests",
    files: "Files",
    products: "Products",
    requestStatuses: "Request statuses",
    fileStatuses: "File statuses",

    creditAssignmentRequestStatuses: "Credit assignment request statuses",
    creditAssignmentFileStatuses: "Credit assignment file statuses",
    creditAssignmentProducts: "Credit assignment products",
    creditAssignmentRequests: "Credit assignment requests",
    creditAssignmentFiles: "Credit assignment files",
    creditAssignmentExternalRequest: "Credit assignment request",

    microCreditRequestStatuses: "Micro-credit request statuses",
    microCreditFileStatuses: "Micro-credit file statuses",
    microCreditProducts: "Micro-credit products",
    microCreditRequests: "Micro-credit requests",
    microCreditFiles: "Micro-credit files",
    microCreditExternalRequest: "Micro-credit request",

    externalProviderRegistrationRequest: "Provider registration request"
  },

  // ===========================================================================
  // Enums
  // ===========================================================================
  requestStatus: {
    INITIAL: "Draft",
    SENT: "Sent"
  },
  statusType: {
    INITIAL: "Initial",
    INTERMEDIATE: "Intermediate",
    SUCCESS: "Final positive",
    FAILURE: "Final negative"
  },
  userType: {
    ADMIN: "Administrator",
    BROKER: "Broker",
    PROVIDER: "Provider",
    CUSTOMER: "Customer"
  },

  // ===========================================================================
  // Public pages
  // ===========================================================================
  externalRequest: {
    tabs: {
      main: "Request parameters",
      customer: "Applicant",
      user: "User access",
      provider: "Provider"
    },
    messages: {
      missingParameters: "Please, supply requested url query parameters",
      submitted:
        "Your request has been submitted. You will receive an e-mail containing further instructions."
    }
  },

  // ===========================================================================
  // Protected pages
  // ===========================================================================
  attachment: {
    fields: {
      name: "Name",
      size: "Size",
      created: "Uploaded",
      person: "By",
      tags: "Tags"
    }
  },
  customer: {
    tabs: {
      main: "General",
      attachments: "Attachments"
    },
    fields: {
      network: "Network",
      companyName: "Company name",
      fiscalCode: "Fiscal code",
      vatNumber: "Vat number"
    }
  },
  file: {
    tabs: {
      main: "General",
      info: "Info",
      attachments: "Attachments",
      messages: "Messages",
      logEntries: "Log",
      help: "Help",
      whereYouAre: "Where you are"
    },
    fields: {
      customer: "Applicant",
      status: "Status",
      exceedingDays: "Exceeding days",
      network: "Network",
      provider: "Provider",
      product: "Product",
      productDescription: "Product description"
    },
    actions: {
      saveInitial: "Save, keeping this status"
    }
  },
  network: {
    tabs: {
      main: "General",
      attachments: "Attachments",
      messages: "Messages",
      settings: "Settings"
    },
    fields: {
      enabledForCreditAssignments: "Enable credit assignments module",
      enabledForMicroCredit: "Enable micro credit module",
      companyName: "Company name",
      urlCode: "URL code",
      fiscalCode: "Fiscal code",
      vatNumber: "Vat number"
    }
  },
  person: {
    tabs: {
      main: "General"
    },
    fields: {
      type: "Type",
      firstName: "First name",
      lastName: "Last name",
      email: "E-mail",
      network: "Network",
      customer: "Customer",
      provider: "Provider"
    }
  },
  product: {
    tabs: {
      main: "General",
      statuses: "Statuses"
    },
    fields: {
      provider: "Provider",
      name: "Name",
      description: "Description"
    }
  },
  provider: {
    tabs: {
      main: "General",
      attachments: "Attachments"
    },
    fields: {
      network: "Network",
      companyName: "Company name",
      fiscalCode: "Fiscal code",
      vatNumber: "Vat number"
    }
  },
  request: {
    tabs: {
      main: "General",
      info: "Info",
      attachments: "Attachments",
      messages: "Messages",
      logEntries: "Log",
      help: "Help"
    },
    fields: {
      network: "Network",
      customer: "Customer",
      status: "Status",
      exceedingDays: "Exceeding days",
      numberOfFiles: "Files"
    },
    actions: {
      saveInitial: "Save, keeping this status"
    }
  },
  status: {
    tabs: {
      main: "General",
      tagAlternatives: "Mandatory tags",
      helpText: "Help text",
      nextStatuses: "Next statuses"
    },
    fields: {
      actionName: "Label assigned to the action yielding this status",
      label: "Label",
      type: "Type",
      failable: "Failable",
      primaryActor: "Type of user controlling the flow in this status",
      maxDays: "Max number of days a request/file should be in this status",
      helpText: "Help text"
    },
    actions: {
      manageTags: "Manage tags",
      addStatusBefore: "Add status (before)",
      addStatusAfter: "Add status (after)",
      addSideStatus: "Add side status"
    }
  },
  statusArrow: {
    fields: {
      label: "Action yielding next status",
      toStatus: "Next status"
    }
  },
  tag: {
    tabs: {
      main: "General"
    },
    fields: {
      label: "Label"
    }
  },

  // ===========================================================================
  // Credit assignments
  // ===========================================================================
  creditAssignmentFile: {
    fields: {
      title: "Title",
      description: "Description",
      requestedAmount: "Amount to assign",
      providedAmount: "Provided amount"
    }
  },
  creditAssignmentProduct: {
    fields: {
      discountFactor: "Discount factor"
    }
  },
  creditAssignmentRequest: {
    fields: {
      title: "Title",
      description: "Description",
      amount: "Amount to assign"
    }
  },

  // ===========================================================================
  // Micro credit
  // ===========================================================================
  microCreditFile: {
    fields: {
      title: "Title",
      description: "Description",
      requestedAmount: "Requested amount",
      providedAmount: "Provided amount"
    }
  },
  microCreditProduct: {
    fields: {
      minAmount: "Min amount",
      maxAmount: "Max amount"
    }
  },
  microCreditRequest: {
    fields: {
      title: "Title",
      description: "Description",
      amount: "Requested amount"
    }
  },

  // ===========================================================================
  // Components
  // ===========================================================================
  userMonitor: {
    logout: "Logout",
    renew: "Keep going",
    userNotLogged:
      "User is not logged: to remind you of this, the user icon in the top bar is stroked out.",
    userUnauthorized:
      "User is not authenticated: to remind you of this, the user icon in the top bar is red and stroked out.",
    sessionExpired:
      "Session expired: to remind you of this, the user icon in the top bar is yellow.",
    sessionAboutExpiring:
      "User is logged in: the session will expire in {days} day(s), {hours} hour(s), {minutes} minute(s) and {seconds} second(s)."
  }
};
